<app-ibase-crud-content
    mode="tree"
    [defaultPaginatorConfig]="CpmCTaskApiService.dPaginatorConfig"
    [flexHeight]="true"
    [deleteRenforced]="true"
    [showColumnToggle]="false"
    [showSearch]="true"
    [showNewButton]="showNewButton"
    [showHelpButton]="false"
    treeSelectionMode="single"
    [treeSelection]="_selection"
    [style.display]="ganttVisible ? 'none' : 'inherit'"
></app-ibase-crud-content>

@if (ganttVisible) {
    <app-task-gantt-panel
        [taskCrud]="this"
        [treeItems]="treeItems"
        [selectedTask]="selectedTask"
        (dateChange)="onGanttDateChange($event)"
        (dateEditRequest)="onGanttDateEditRequest($event)"
        (taskSelected)="onGanttTaskSelected($event)"
        [style.display]="ganttVisible ? 'inherit' : 'none'"
    ></app-task-gantt-panel>
}

@if (_helpVisible) {
    <p-dialog
        header="Help"
        [modal]="true"
        [(visible)]="_helpVisible"
        [resizable]="true"
        [maximizable]="true"
        appendTo="body"
    >
        <p>TODO</p>

        <div class="p-dialog-footer">
            <p-button
                severity="secondary"
                icon="pi pi-times"
                type="button"
                label="Close"
                (click)="_helpVisible = false"
            ></p-button>
        </div>
    </p-dialog>
}
